import React, { useState } from 'react';
import Lottie from 'react-lottie';
import animationData from '../../assets/cropanimationformodal.json';

const FieldModal = ({ setflag, fields, onUpdate }) => {
  const [mic, setMic] = useState(false);
  const [updatedFields, setUpdatedFields] = useState(fields); // State for updated field data
  const synth = window.speechSynthesis;

  const closeModal = () => {
    setflag(null);
    if (mic) toggleSpeech(false); // Stop speaking when modal closes
  };

  const handleMic = () => {
    const newMicState = !mic;
    setMic(newMicState);
    toggleSpeech(newMicState);
  };

  const toggleSpeech = (speak) => {
    if (speak) {
      speakDetails();
    } else {
      window.speechSynthesis.cancel(); // Stop speaking
    }
  };

  const speakDetails = () => {
    const details = `अस्सलाम ओ अलेकुम मोज़िज़ सरफ़ीन, आज आपके खेत ${updatedFields.fieldName} की रिपोर्ट प्रस्तुत की जा रही है। आपके खेत में लगाई गई फसल का नाम ${updatedFields.cropName} है। कुल जमीन का क्षेत्रफल ${updatedFields.area} एकड़ है। इसका मौसम ${updatedFields.season} है। बुवाई की तारीख ${new Date(updatedFields.sowingDate).toLocaleDateString()} है। और फसल कटाई की तारीख ${new Date(updatedFields.harvestingDate).toLocaleDateString()} है। इसमें ${updatedFields.fertilizerApplication} खाद का इस्तेमाल किया गया है।`;

    const utterance = new SpeechSynthesisUtterance(details);
    utterance.lang = 'hi-IN'; // Set the language to Hindi

    function setVoiceAndSpeak() {
      const voices = synth.getVoices();
      const hindiVoice = voices.find(
        (voice) => voice.name === 'Microsoft Hemant - Hindi (India)'
      );
      if (hindiVoice) {
        utterance.voice = hindiVoice;
        synth.speak(utterance);
      } else {
        console.log('Microsoft Hemant - Hindi (India) voice not available.');
      }
    }

    if (synth.getVoices().length > 0) {
      setVoiceAndSpeak();
    } else {
      synth.onvoiceschanged = () => {
        setVoiceAndSpeak();
        synth.onvoiceschanged = null; // Clean up event handler
      };
    }
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setUpdatedFields({
      ...updatedFields,
      [name]: value,
    });
  };

  const updateField = () => {
    onUpdate(updatedFields); // Call parent component's update function with updated data
    closeModal(); // Close the modal after updating
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const harvestingDate = updatedFields?.harvestingDate;
const validDate = harvestingDate && !isNaN(new Date(harvestingDate).getTime()) ? new Date(harvestingDate) : null;  // Fallback to current date if invalid

const formattedDate = validDate ? validDate.toISOString().split('T')[0] : null;  // Get date in YYYY-MM-DD format



const sowingDate = updatedFields?.sowingDate;
const sowingvalidDate = sowingDate && !isNaN(new Date(sowingDate).getTime()) ? new Date(sowingDate) : new Date();  // Fallback to current date if invalid

const sowingFormattedDate = sowingvalidDate?.toISOString().split('T')[0];  // Get date in YYYY-MM-DD format



  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 overflow-y-auto overflow-x-hidden ">
      <div className="bg-white w-full max-w-4xl sm:max-h-full p-8 rounded-xl shadow-2xl absolute top-2 md:top-32 transition duration-300 ease-out transform hover:scale-105">
        <button
          className="md:absolute md:top-5  w-7 h-7 absolute right-5 text-gray-700 hover:text-white bg-gray-200 hover:bg-red-600 rounded-full p-0 cursor-pointer transition duration-300"
          onClick={closeModal}
          aria-label="Close modal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            className="text-center w-6 h-6"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <h3 className="text-3xl font-bold text-emerald-700 mb-6">
          Field Details{' '}
          <span className="cursor-pointer" onClick={handleMic}>
            {mic ? '🔊' : '🔈'}
          </span>
        </h3>

        <div className="flex flex-col md:flex-row md:items-start space-y-6 md:space-y-10 md:space-x-10">
         <div className='md:relative md:top-24' >
         <Lottie
            options={defaultOptions}
            height={250}
            width={250}
            className="rounded-lg  shadow-lg mx-auto"
          />
         </div>
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Field Name */}
            <div className="flex flex-col">
              <label className="text-lg font-semibold underline">Field Name:</label>
              <input
                type="text"
                name="fieldName"
                value={updatedFields.fieldName}
                onChange={handleFieldChange}
                className="mt-2 border rounded p-2 w-full"
              />
            </div>
            {/* Crop Name */}
            <div className="flex flex-col">
              <label className="text-lg font-semibold underline">Crop Name:</label>
           
              <input
                type="text"
                name="cropName"
                value={updatedFields.cropName}
                onChange={handleFieldChange}
                className="mt-2 border rounded p-2 w-full"
              />
            </div>
            {/* Area */}
            <div className="flex flex-col">
              <label className="text-lg font-semibold underline">Area (acres):</label>
              <p className="mt-2 border rounded p-2 w-full">{updatedFields.area} acres</p>
            </div>
            {/* Season */}
            <div className="flex flex-col">
              <label className="text-lg font-semibold underline">Season:</label>
              <input
                type="text"
                name="season"
                value={updatedFields.season}
                onChange={handleFieldChange}
                className="mt-2 border rounded p-2 w-full"
              />
            </div>
            {/* Sowing Date */}
            <div className="flex flex-col">
              <label className="text-lg font-semibold underline">Sowing Date:</label>
              <input
                type="date"
                name="sowingDate"
                value={sowingFormattedDate}
                onChange={handleFieldChange}
                className="mt-2 border rounded p-2 w-full"
              />
            </div>
            {/* Harvesting Date */}
            <div className="flex flex-col">
              <label className="text-lg font-semibold underline">Harvesting Date:</label>
              <input
                type="date"
                name="harvestingDate"
                value={formattedDate}
                onChange={handleFieldChange}
                className="mt-2 border rounded p-2 w-full"
              />
            </div>
            {/* Fertilizer Application */}
            <div className="flex flex-col sm:col-span-2">
              <label className="text-lg font-semibold underline">Fertilizer Application:</label>
              <input
                type="text"
                name="fertilizerApplication"
                value={updatedFields.fertilizerApplication}
                onChange={handleFieldChange}
                className="mt-2 border rounded p-2 w-full"
              />
            </div>
          </div>
        </div>
        <div className="flex justify-end mt-6">
          <button
            onClick={updateField}
            className="text-green-300 p-2 w-full md:w-[15%] bg-emerald-500 rounded-md"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default FieldModal;

